import React, { useState } from "react"
import Layout from "gatsby-theme-blank/src/components/Layout/layout"
import PropTypes from "prop-types"
import SEO from "gatsby-theme-blank/src/components/seo"
import ListActualites from "gatsby-theme-blank/src/components/Home/Actualites/actualites"
import ContenuLibre from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre"
import CarnetAdresse from "gatsby-theme-blank/src/components/Home/CarnetAdresse/carnet-adresse"
import AgendaEvenements from "../components/Home/Agenda/agenda"
import ListNePasManquer from "gatsby-theme-blank/src/components/Home/NePasManquer/ne-pas-manquer"
import ListPartenaires from "gatsby-theme-blank/src/components/Home/Partenaires/partenaires"
import AccesDirects from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct"
import {
  sectionFirst,
  sectionSecond,
  sectionThird,
  sectionNePasManquer,
  sectionPartenaires,
  sectionAccesDirect,
  sectionAccesDirectActive,
} from "../styles/index.module.scss"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import NotificationPopup from "gatsby-theme-blank/src/components/NotificationPopup/notification-popup"
import styled from "styled-components"
import { AccesDirectContext } from "gatsby-theme-amaryllis/src/components/acces-direct-context"

const IndexPage = ({ location }) => {
  const buildInfos = useBuildData().site_settings
  const [isAccesDirectOpen, setIsAccesDirectOpen] = useState(false)

  return (
    <AccesDirectContext.Provider
      value={{ isAccesDirectOpen, setIsAccesDirectOpen }}
    >
      <Layout isIndex={true} message={buildInfos.website_name}>
        <SEO
          description={buildInfos.seo.description_tag}
          title={buildInfos.seo.title_tag || "Accueil"}
        />
        <NotificationPopup
          popupContent={buildInfos.notification_popup.value}
          location={location}
        />
        <div className={sectionFirst}>
          <ListActualites />
          <AgendaEvenements />
        </div>
        <ColoredDiv
          className={`${sectionAccesDirect} ${
            isAccesDirectOpen ? sectionAccesDirectActive : ""
          }`}
        >
          <AccesDirects />
        </ColoredDiv>
        <div className={sectionSecond}>
          <CarnetAdresse />
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_1" />
        </div>
        <div className={sectionNePasManquer}>
          <ListNePasManquer />
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_2" />
        </div>
        <div className={sectionThird}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_3" />
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_4" />
        </div>
        <div className={sectionPartenaires}>
          <ListPartenaires />
        </div>
      </Layout>
    </AccesDirectContext.Provider>
  )
}

const ColoredDiv = styled.div`
  &:empty {
    height: 0;
  }
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

//-----------------------Prop-Types---------------------------//

IndexPage.propTypes = {
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default IndexPage
